import type { ManagerialDashboardRecentOrder } from '@/types/api'
import { formatFullCurrencyBrl } from './managerial-kpis'

export type RecentOrderStatus = ManagerialDashboardRecentOrder['status']

export type RecentOrderView = {
  id: string
  dateLabel: string
  timeLabel: string
  customerName: string
  formattedAmount: string
  status: RecentOrderStatus
  statusLabel: string
}

export const RECENT_ORDER_STATUS_LABELS: Record<RecentOrderStatus, string> = {
  paid: 'Pago',
  pending: 'Pendente',
  canceled: 'Cancelado',
}

export const EMPTY_RECENT_ORDER_VIEWS: RecentOrderView[] = []

export const RECENT_ORDERS_LIST_LIMIT = 15

export function formatRecentOrderDateTime(isoDateTime: string): { dateLabel: string; timeLabel: string } {
  const match = isoDateTime.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/)
  if (!match) {
    return { dateLabel: '—', timeLabel: '—' }
  }

  return {
    dateLabel: `${match[3]}/${match[2]}`,
    timeLabel: `${match[4]}:${match[5]}`,
  }
}

export function toRecentOrderView(order: ManagerialDashboardRecentOrder): RecentOrderView {
  const when = formatRecentOrderDateTime(order.occurred_at)
  return {
    id: String(order.id),
    dateLabel: when.dateLabel,
    timeLabel: when.timeLabel,
    customerName: order.customer_name,
    formattedAmount: formatFullCurrencyBrl(order.amount),
    status: order.status,
    statusLabel: RECENT_ORDER_STATUS_LABELS[order.status],
  }
}

export function mapRecentOrders(orders: ManagerialDashboardRecentOrder[]): RecentOrderView[] {
  return orders.slice(0, RECENT_ORDERS_LIST_LIMIT).map(toRecentOrderView)
}
